import { atom } from "jotai"

export const textBannerVisibleAtom = atom<boolean>(true)
